var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMenu06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2388 1C13.2388 1 1 9 1 9.41791V11.4478C1 11.8657 1.35821 12.2239 1.77612 12.2239H3.02985V23.9254C3.02985 24.5224 3.50746 25 4.10448 25H22.3731C22.9701 25 23.4478 24.5224 23.4478 23.9254V12.1642H24.7015C25.1194 12.1642 25.4776 11.806 25.4776 11.3881V9.35821C25.4776 8.9403 13.2388 1 13.2388 1Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.403 12.3433H10.0746C9.41793 12.3433 8.88062 12.8806 8.88062 13.5373V25H17.6567V13.5373C17.6567 12.8806 17.1194 12.3433 16.403 12.3433Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8506 14.6715H11.6865C11.4477 14.6715 11.2686 14.8506 11.2686 15.0894V22.3133C11.2686 22.5521 11.4477 22.7312 11.6865 22.7312H14.8506C15.0895 22.7312 15.2686 22.5521 15.2686 22.3133V15.0894C15.2686 14.8506 15.0895 14.6715 14.8506 14.6715Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2386 9.23877C14.1289 9.23877 14.8506 8.51708 14.8506 7.62683C14.8506 6.73658 14.1289 6.01489 13.2386 6.01489C12.3484 6.01489 11.6267 6.73658 11.6267 7.62683C11.6267 8.51708 12.3484 9.23877 13.2386 9.23877Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenu06);
export default __webpack_public_path__ + "static/media/ico_menu_06.6aa83ee9.svg";
export { ForwardRef as ReactComponent };